"use client";

import { generateLocalizedURL } from "@/utils/url";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";

const dateFormater = new Intl.DateTimeFormat("fa-IR", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

export const ProgramEpisodes = ({ episodes }: { episodes: any }) => {
  
  const [visibleCount, setVisibleCount] = useState<number>(10);
  
  const newItemRef = useRef<HTMLLIElement | null>(null);
  const newBatchIndexRef = useRef<number>(-1);
  
  const handleShowMore = () => {
    newBatchIndexRef.current = visibleCount;
    setVisibleCount((prevCount) => Math.min(prevCount + 10, episodes.length));
  };

  useEffect(() => {
    if (newItemRef.current) {
      newItemRef.current.scrollIntoView({ behavior: "smooth" });
    }
    newBatchIndexRef.current = - 1;
  }, [visibleCount]);

  const visibleEpisodes = episodes.slice(0, visibleCount);

  if (!visibleEpisodes.length) {
    return null;
  }
  
  return (
    <>
      <ul className="episodes__list">
        {visibleEpisodes?.map((episode: any, index: number) => {
          const firstBroadcastDate = episode.firstBroadcastDate || episode.createdAt || episode.video.createdAt;
          return episode.video && <li
            key={episode.id}
            className="episodes__item"
            ref={index + 1 === newBatchIndexRef.current ? newItemRef : null}
          >
            <div className="episode-card">
              <Image
                src={episode.image}
                alt={episode.title}
                width={208}
                height={117}
                className="episode-card__image"
              />
              <div className="episode-card__content">
                <Link
                  href={generateLocalizedURL(`video/${episode.video.id}`, episode.video.language)}
                  className="episode-card__link"
                  prefetch={false}
                  shallow={true}
                >
                  <h3 className="episode-card__title">{episode.title}</h3>
                </Link>
                {firstBroadcastDate && <time
                  className="episode-card__time"
                  dateTime={firstBroadcastDate}
                >
                  {dateFormater.format(new Date(firstBroadcastDate))}
                </time>}
              </div>
            </div>
          </li>;
        })}
      </ul>
      {visibleCount < episodes.length && (
        <div className="episodes__show-more">
          <button
            onClick={handleShowMore}
            className="episodes__show-more-button"
          >
            قسمت‌‌های بیشتر
          </button>
        </div>
      )}

    </>
  );
};